import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getGrantableBundles = api(async function getGrantableBundles() {
    return query(
        gql`
            query GetGrantableBundles {
                getGrantableBundles
            }
        `,
        {},
        { returns: "getGrantableBundles" }
    )
})
